import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tooltip from './';
const WithToolTip = ({ children, title, ...rest }) => {
    if (!title) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs(Tooltip, { triggers: ['hover'], placement: "bottom", ...rest, children: [_jsx(Tooltip.Target, { children: children }), _jsx(Tooltip.Content, { children: title })] }));
};
export default WithToolTip;
